// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudOutlinedSvg from "@fishx/icons-svg/es/asn/CloudOutlined";
import FishxIcon from '../components/FishxIcon';

var CloudOutlined = function CloudOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudOutlinedSvg
  }));
};

CloudOutlined.displayName = 'CloudOutlined';
export default React.forwardRef(CloudOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudOutlined.js
// module id = 2247
// module chunks = 0